import * as React from 'react';
import { createContextValueGetter } from '../../utils/helper';
export var SegmentedControlContext = React.createContext({
    activeId: '',
});
export var getContextValue = createContextValueGetter();
